/**
 * @file Purchase PPD Individual Print Modal.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import withModal from '../global/modal/withModal';
import { PURCHASE_PPD_PURCHASE_INDIVIDUAL_PRINT } from '../../constants/modals';
import { PPD_CART_ITEM_TYPES } from '../../constants/ppd-purchase';
import Button from '../global/Button';
import Spinner from '../global/Spinner';
import CustomControl from '../global/CustomControl';
import { formatPriceForDisplay } from '../../util/format-money';
import { isCartItemSelected } from '../../util/ppd-purchase';

class PurchasePpdIndividualPrintModal extends Component {
  static propTypes = {
    actionProps: PropTypes.shape({
      comparedFaces: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
      photo: PropTypes.shape({
        id: PropTypes.string,
        thumbnail_urls: PropTypes.arrayOf(
          PropTypes.shape({
            width: PropTypes.number,
            height: PropTypes.number,
            url: PropTypes.string,
          }),
        ),
      }),
    }),
    album: PropTypes.shape({
      id: PropTypes.string,
      photo_pricing: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }),
    }),
    cart: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.oneOf(Object.keys(PPD_CART_ITEM_TYPES)),
        photo: PropTypes.shape({
          id: PropTypes.string,
        }),
        printSize: PropTypes.shape({
          id: PropTypes.string,
        }),
        printPackage: PropTypes.shape({
          id: PropTypes.string,
        }),
        quantity: PropTypes.number,
      }),
    ),
    toggleCartItem: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired,
  };

  getSizeLabel = name => {
    return name.replace('x', '×');
  };

  render() {
    const {
      actionProps: { photo },
      cart,
      toggleCartItem,
      onRequestClose,
      album,
    } = this.props;

    if (!album) {
      return <Spinner />;
    }

    const photoPricing = get(album, 'photo_pricing');
    const printSizes = get(photoPricing, 'print_items.records', []);

    return (
      <div className="ppd-print-size">
        <div>
          <div className="text-center mb-2">
            <h3 className="text-base mb-1">Purchase Individual Prints</h3>
            <p className="mb-0">
              Select one or more print sizes below to add them to your cart:
            </p>
          </div>

          <div className="print-size-rows">
            {printSizes.map(size => (
              <a
                href="#"
                key={size.id}
                className="print-size-row-item text-md"
                onClick={event => {
                  event.preventDefault();
                  toggleCartItem(
                    photo.id,
                    PPD_CART_ITEM_TYPES.INDIVIDUAL_PRINT,
                    size,
                  );
                }}
              >
                <CustomControl
                  id={size.id}
                  type="checkbox"
                  className="mr-1"
                  checked={isCartItemSelected(
                    cart,
                    photo.id,
                    PPD_CART_ITEM_TYPES.INDIVIDUAL_PRINT,
                    size,
                  )}
                  readOnly
                  label={`Select size ${size.type.name}`}
                  labelSrOnly
                />
                <strong className="text-dark">
                  {this.getSizeLabel(size.type.name)}
                </strong>
                <span className="print-size-row-item-price text-sm ml-auto">
                  ${formatPriceForDisplay(size.price.value, true)}
                </span>
              </a>
            ))}
          </div>
        </div>
        <div className="modal-footer">
          <Button onClick={onRequestClose} btnBlock className="text-center">
            Continue shopping
          </Button>
        </div>
      </div>
    );
  }
}

export { PurchasePpdIndividualPrintModal as PurchasePpdIndividualPrintModalComp };

export default withModal(PurchasePpdIndividualPrintModal, {
  name: PURCHASE_PPD_PURCHASE_INDIVIDUAL_PRINT,
  size: 'sm',
  type: 'full',
  hideHeader: true,
});
